<template>
  <div class="approval-template-editor-view h-100">
    <TemplateEditor />
  </div>
</template>

<script setup>
import TemplateEditor from '@/components/jobProfiles/approvals/TemplateEditor.vue';

defineOptions({ name: 'ApprovalTemplateEditorView' });
</script>
